<template>
    <div id="bill">
        <div class="head-tool">
            <span @click="$router.go(-1)">返回</span>
            <span class="tc">账户流水记录</span>
            <router-link class="tr" tag="span" to="/">首页</router-link>
        </div>

        <ul v-infinite-scroll="getBillList">
            <li v-for="val in list">
                <p>
                    <span v-if="val.title">{{val.title}} -</span> {{val.info}}
                    <span class="time">{{val.create_time}}</span>
                </p>

            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "Bill",
        data (){
            return {
                page : 1,
                limit : 20,
                last : 1,
                list : []
            }
        },
        methods : {
            getBillList(){
                if(this.page > this.last){
                    return;
                }
                this.axios.post('/api/bill/getBillList',{
                    page : this.page,
                    limit : this.limit,
                }).then(r => {
                    this.page ++;
                    r.data.data.data.forEach(v => {
                        this.list.push(v);
                    })
                    this.last = r.data.data.last_page;
                })
            }
        },
        created() {
            // this.getBillList();
        }
    }
</script>

<style lang="less">
    #bill{background: #f6f6f7;overflow: auto;height: 100%;
        .head-tool{display: flex;padding: 26px 20px;background: #fff;border-bottom: 1px solid #efefef;
            span{flex:1;font-size: 30px;color:#333;
                i{font-size: 30px;}
            }
        }
        .alert{background: #fdf6ec;color: #e6a23c;padding: 20px;font-size: 26px;}
        ul{overflow: auto;height:calc(100% - 100px);background: #fff;
            li{padding: 20px;border-bottom: 1px solid #efefef;overflow: auto;
                h4{font-size: 30px;font-weight: 400;color: #333;}
                .time{color: #999;font-size: 24px;float: right;}
                .fr{padding-top: 40px;font-size: 26px;color:#333;}
            }
        }


    }
</style>
